import "app/components/React/UserSettingDropdown/UserSettingsDropdown.scss";
import type { FC } from "react";
import type { IAvailableSolutionsNewSidebar } from "app/components/sidebar3/primary-side-bar/secondary-actions/Solutions/SolutionsSwitcherMenuComponent";
import {
    AccountSwitcherItem,
    AccountSwitcherWrapper,
    AccountTitle,
} from "app/components/sidebar3/primary-side-bar/secondary-actions/Solutions/SolutionItemDropdown.styles";
import { swSettings } from "app/common/services/swSettings";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { i18nFilter } from "app/filters/i18nFilter";
import { getBaseUrl } from "app/components/sidebar3/primary-side-bar/utils";
import { buildSwitchAccountUrl, getReturnUrl } from "app/user-data/Solutions";
interface IAccountSwitcher {
    sol: IAvailableSolutionsNewSidebar;
}

export const AccountSwitcher: FC<IAccountSwitcher> = ({ sol }) => {
    const CurrentUser = swSettings.user.id;
    const moveToAccount = (sol, user) => {
        window.location.href = buildSwitchAccountUrl(
            getBaseUrl(swSettings.swsites.login_handler),
            user.userId,
            getReturnUrl(sol),
        );
    };
    return (
        <AccountSwitcherWrapper>
            <AccountTitle>{i18nFilter()("sidebar.account_switcher.choose.text")}</AccountTitle>
            {sol.usersInMySolution.length > 0
                ? sol.usersInMySolution.map((user) => (
                      <AccountSwitcherItem
                          onClick={() => {
                              moveToAccount(sol, user);
                          }}
                      >
                          <SWReactIcons
                              iconColor={colorsPalettes.carbon[400]}
                              iconName={CurrentUser === user.userId ? "checked" : "user"}
                              size={"xs"}
                          />
                          {user.name}
                      </AccountSwitcherItem>
                  ))
                : null}
        </AccountSwitcherWrapper>
    );
};
